import React from 'react';

// Returns true if the container width is greater than or equal to the
// minWidth. Returns true if container is not defined
export function useResponsive(
  minWidth: number,
  container: HTMLElement | undefined | null
): boolean {
  const [isWide, setIsWide] = React.useState<boolean>(() => {
    return container ? container.clientWidth >= minWidth : true;
  });

  React.useLayoutEffect(() => {
    if (!container) {
      return;
    }
    const resizeObserver = new ResizeObserver(() => {
      setIsWide(container ? container.clientWidth >= minWidth : true);
    });

    resizeObserver.observe(container);

    return () => {
      resizeObserver.disconnect();
    };
  }, [minWidth, container]);

  return isWide;
}
